import { useConnection } from 'hooks/useConnection'
import { useResolveCurrencyAddress } from 'hooks/useResolveCurrencyAddress'
import { Navigate, useParams } from 'react-router-dom'
import { isNativeCurrencyId } from 'utils/currencyId'

import { WRAPPED_NATIVE_CURRENCY } from '../../constants/tokens'
import AddLiquidity from './index'

export function RedirectDuplicateTokenIds() {
  const { currencyIdA, currencyIdB } = useParams<{ currencyIdA: string; currencyIdB: string; feeAmount?: string }>()

  const { chainId } = useConnection()

  const currencyAAdress = useResolveCurrencyAddress(currencyIdA)
  const currencyBAdress = useResolveCurrencyAddress(currencyIdB)

  // prevent weth + eth
  const isETHOrWETHA =
    isNativeCurrencyId(currencyIdA, chainId) ||
    (chainId !== undefined && currencyIdA === WRAPPED_NATIVE_CURRENCY[chainId]?.address)
  const isETHOrWETHB =
    isNativeCurrencyId(currencyIdB, chainId) ||
    (chainId !== undefined && currencyIdB === WRAPPED_NATIVE_CURRENCY[chainId]?.address)

  if (currencyIdA && currencyIdB && (currencyAAdress === currencyBAdress || (isETHOrWETHA && isETHOrWETHB))) {
    return <Navigate to={`/liquidity/v3/add/${currencyIdA}`} replace />
  }
  return <AddLiquidity />
}
